import React, { useState, useEffect } from 'react';
import useApi from '../../Hooks/useApi';

import './QuoteDatabase.css';

// custom components
import QuotesDataTable from '../../Components/QuotesDataTable/QuotesDataTable';
//carbon components
import { DataTableSkeleton } from 'carbon-components-react';

function QuoteDatabase(props) {
	//get props
	const { token, quoteToEdit, setQuoteToEdit, setSalesOrderToEdit } = props;
	//set state
	const [refresh, setRefresh] = useState(false);
	// fetch the inventory data
	const apiPath = '/quotes';
	const { error, loading, data, fetchData } = useApi(token, apiPath);

	// additional table-specific vars
	const collator = new Intl.Collator();
	const propSortInfo = {
		columnId: 'description',
		direction: 'NONE',
	};

	if (error) {
		console.error(error);
		return (
			<div>
				<p>An error has occurred, please refresh the page</p>
			</div>
		);
	}

	if (loading) {
		return (
			<div id="homeContainer">
				<h3 id="quoteDBTitle">Quote Database</h3>
				<div id="skeletonDataTableCont">
					<DataTableSkeleton showToolbar={false} id="skeletonTable"></DataTableSkeleton>
				</div>
			</div>
		);
	}

	return (
		<div id="homeContainer">
			<h3 id="quoteDBTitle">Quote Database</h3>
			<QuotesDataTable
				token={token}
				setSalesOrderToEdit={setSalesOrderToEdit}
				setQuoteToEdit={setQuoteToEdit}
				quotesData={data.quotes}
				refreshData={fetchData}
			/>
		</div>
	);
}

export default QuoteDatabase;
